//libraries
import _ from 'lodash';

/**
 * Import all constants as an object.
 */
import * as ActionType from "../../constants/actionType";


var initialState = {
    token: null,
    code: "",
    isAuthenticated: false,
    finalResult: null,
    profile: null
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
export default function (state, action) {
    state = state || initialState;

    switch (action.type) {
        case ActionType.LOG_IN_SUCCESS:
            return _.assign({}, state, {
                isAuthenticated: true,
                token: action.payload.token,
                code: action.payload.code,
                finalResult: action.payload.finalResult,
                profile: action.payload.profile
            });

        case ActionType.LOG_IN_FAILURE:
            return _.assign({}, state, {
                isAuthenticated: false,
                token: null,
                code: "",
                finalResult: null,
                profile: null
            });

        case ActionType.LOG_OUT:
            return _.assign({}, state, {
                token: null,
                code: "",
                isAuthenticated: false,
                finalResult: null,
                profile: null
            });

        default:
            return state;
    }
}